
import {isEmpty} from "../utils/commons";
import {submitPasswordReset} from "../apis/security_apis";
import * as emailValidator from "email-validator";

export const PASSWORD_RESET_ON_CHANGE = "passwordResetOnChange";
export const PASSWORD_RESET_ON_VALIDATE = "passwordResetOnValidate";
const PASSWORD_RESET_SUBMITTING = "passwordResetSubmitting";
const PASSWORD_RESET_SUBMITTED = "passwordResetSubmitted";
const PASSWORD_RESET_FIELD_CLEAN = "resetPasswordFieldClean";

const initLoginErrors = () => ({
    email: "",
})

const initState = () => ({
        email: "",
        error: "",
        info: "",
        submitting: false,
        fieldErrors: initLoginErrors(),
})

const state = initState();

const mutations = {
    [PASSWORD_RESET_ON_CHANGE] (state, payload) {
        Object.assign(state, {[payload.name]:payload.value});
    },
    [PASSWORD_RESET_ON_VALIDATE] (state, payload) {
        Object.assign(state, {fieldErrors: {...payload}});
    },
    [PASSWORD_RESET_SUBMITTING] (state) {
        Object.assign(state, {submitting: true, error: "", info: ""});
    },
    [PASSWORD_RESET_SUBMITTED] (state, payload) {
        Object.assign(state, {submitting: false, error: payload.error, info: payload.info});
    },
    [PASSWORD_RESET_FIELD_CLEAN] (state) {
        Object.assign(state, initState());
    }
}

const actions = {
    [PASSWORD_RESET_ON_CHANGE] ({commit}, payload) {
        commit(PASSWORD_RESET_ON_CHANGE, payload)
    },
    [PASSWORD_RESET_ON_VALIDATE] ({commit, state}) {
        let errors = {};
        if(isEmpty(state["email"])) {
            errors["email"] = "This field is required";
        }else if(!emailValidator.validate(state["email"])) {
            errors["email"] = "The email is invalid";
        }

        commit(PASSWORD_RESET_ON_VALIDATE, errors);
        if(Object.keys(errors).length > 0) {
            commit(PASSWORD_RESET_ON_CHANGE, {name: "error", value: "Some fields invalid"});
        }else {
            commit(PASSWORD_RESET_ON_CHANGE, {name: "error", value: ""});
        }
    },
    resetPassword ({commit, state}) {

        commit(PASSWORD_RESET_SUBMITTING);
        submitPasswordReset({email: state.email})
            .then(() => {
                    commit(PASSWORD_RESET_SUBMITTED, {info: "Password reset request submitted. You should receive email with further details shortly."});
                },
                (results) => {
                    let error = !results.error? "Failed submitting password reset.": results.error;
                    commit(PASSWORD_RESET_SUBMITTED, {info: "", "error": error});
                })


    },
    [PASSWORD_RESET_FIELD_CLEAN] ({commit}) {
        commit(PASSWORD_RESET_FIELD_CLEAN);
    }
}


export default {
    state,
    mutations,
    actions
}
